import { Button } from "@/components/ui/button";


export const AuthButton = ({ isLoading, children }: AuthButtonProps) => {
  return (
    <Button
      type="submit"
      className="w-full bg-blue-600 hover:bg-blue-700"
      disabled={isLoading}
    >
      {children}
    </Button>
  );
};